module.exports = __webpack_public_path__ + "media/images/web_suite/icon_apple-50e1c07374d36ecd337c65feb52583c2.png";